import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles({
  card: {
    display: 'flex',
  },
  cardDetails: {
    flex: 1,
  },
  cardMedia: {
    width: 200,
    backgroundColor:"red",
    resize:"vertical"
  },
  descBold:{
    fontSize:18,
    fontWeight:"bold",
    marginLeft:10,
    marginRight:10,
    textTransform:"capitalize",
    color:"black",
  }
});

export default function FeaturedPost(props) {
  const classes = useStyles();
  const { post } = props;
  let backgroundColor = "white"
  if(props.bgColor){
    backgroundColor = props.bgColor
  }
  return (
    <Grid item xs={12} md={6}>
      <CardActionArea component="a" href="#" >
        <Card className={classes.card} style={{minHeight:350,backgroundColor}}>
          <div className={classes.cardDetails}>
            <CardContent>
              <Typography component="h2" variant="h5">
                {post.title}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                &nbsp;
              </Typography>
              <Typography variant="subtitle1" paragraph>
                <span variant={"inherit"}>{post.descriptionStart}</span>
                <span className={classes.descBold}>{post.descriptionBold}</span>
                {post.description}
              </Typography>
              <Typography variant="subtitle1" color="primary">
                Read more...
              </Typography>
            </CardContent>
          </div>
          <Hidden xsDown>
            <CardMedia
                className={classes.cardMedia}
                image={post.image}
                title={post.imageTitle}
            />
          </Hidden>
        </Card>
      </CardActionArea>
    </Grid>
  );
}

FeaturedPost.propTypes = {
  post: PropTypes.object,
};
